import { useTheme, Stack, Box, Typography, Button, Link, InternalIcon } from "@carrotfertility/carotene-core"
import React, { useState } from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { BorderedInfoBox } from "#/components/shared/BorderedInfoBox"
import { CarrotCompanionTile } from "#/components/care-team/CarrotCompanionTile"
import { JourneyChangeDialogContainer } from "#/components/carrot-plans/journey-change/JourneyChangeDialog"
import { useGetInProgressCarrotPlanRequestType } from "#/components/carrot-plans/hooks/useGetInProgressCarrotPlanRequestType"
import { CarrotPlansPaths } from "#/utils/Paths"
import { Link as RouterLink } from "react-router-dom"
import { useGetCarrotPlanRequestStatus } from "#/components/carrot-plans/hooks/useCarrotPlanRequestStatus"
import { ThanksForUpdatingUsTile } from "#/components/home/carrot-plan/ThanksForUpdatingUsTile"

export const SensitiveStateHomeMain = (): JSX.Element => {
  const theme = useTheme()
  const inProgressCarrotPlanRequestTypeQuery = useGetInProgressCarrotPlanRequestType()
  const showContinueRequestLink = inProgressCarrotPlanRequestTypeQuery.data != null

  const cpRequestStatusQuery = useGetCarrotPlanRequestStatus()
  const carrotPlanIsOnTheWay = cpRequestStatusQuery.data?.carrotPlanIsOnTheWay
  const isLoading = cpRequestStatusQuery.isLoading || inProgressCarrotPlanRequestTypeQuery.isLoading

  return (
    <Stack spacing={theme.spacing(theme.tokens.spacing.lg)}>
      {!isLoading && (
        <Box
          padding={(theme) => theme.spacing(theme.tokens.spacing.lg)}
          bgcolor={(theme) => theme.palette.info.light}
          borderRadius={(theme) => theme.tokens.borderRadius.md}
        >
          <Stack spacing={theme.spacing(theme.tokens.spacing.lg)}>
            {carrotPlanIsOnTheWay ? (
              <ThanksForUpdatingUsTile />
            ) : (
              <SensitiveScenarioCarrotPlanMessage showContinueRequestLink={showContinueRequestLink} />
            )}
            <CarrotCompanionTile />
          </Stack>
        </Box>
      )}
    </Stack>
  )
}

function SensitiveScenarioCarrotPlanMessage({
  showContinueRequestLink
}: {
  showContinueRequestLink: boolean
}): JSX.Element {
  const intl = useIntl()
  const [toggleJourneyChangeModalOpen, setToggleJourneyChangeModalOpen] = useState(false)
  function openModal(event: { preventDefault: () => void }) {
    event.preventDefault()
    setToggleJourneyChangeModalOpen(true)
  }

  return (
    <BorderedInfoBox>
      <Box
        display="flex"
        flexDirection="column"
        gap={(theme) => theme.spacing(theme.tokens.spacing.md)}
        alignSelf="stretch"
        alignItems="start"
      >
        <Typography variant="h4">
          {intl.formatMessage({
            defaultMessage: "Your Carrot Plan"
          })}
        </Typography>
        <Typography variant="body1">
          {intl.formatMessage({
            defaultMessage:
              "We're here for you. Reach out to your Carrot Companion anytime, or, if you are ready, update your journey to receive a new Carrot Plan."
          })}
        </Typography>
        {showContinueRequestLink ? (
          <Link
            component={RouterLink}
            to={CarrotPlansPaths.REDIRECT}
            endIcon={<InternalIcon fontSize="small" color="primary" />}
          >
            <FormattedMessage defaultMessage="Continue sharing your update" />
          </Link>
        ) : (
          <Button variant={"contained"} color={"secondary"} onClick={openModal}>
            <FormattedMessage defaultMessage="Update journey" />
          </Button>
        )}
      </Box>
      {toggleJourneyChangeModalOpen && (
        <JourneyChangeDialogContainer origin="cta" setToggleModalFromCta={setToggleJourneyChangeModalOpen} />
      )}
    </BorderedInfoBox>
  )
}
